module.exports = __webpack_public_path__ + "static/media/RobotoCondensed-Italic.198e3f07.ttf";